import {
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToggle,
  IonToolbar,
  ToggleChangeEventDetail,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import Logic, {
  currentUnits,
  FieldStatTypeInterface,
  FieldValueType,
  powerUnits,
  resistanceUnits,
  voltageUnits,
} from "../../helpers/logic";

import { returnDownForward } from "ionicons/icons";

import "./style.css";
import myUtil, { IS_EMBED } from "../../helpers/cha-utils";
import Sidebar from "../../components/Sidebar";

const Index: React.FC = () => {
  const [voltage, setVoltage] = useState<number>(110);
  const [voltageUnit, setVoltageUnit] = useState<string>("V");
  const voltageInput = myUtil.pfn(
    voltage * voltageUnits[voltageUnit]!.modifier
  );

  const [current, setCurrent] = useState<number>(0.4);
  const [currentUnit, setCurrentUnit] = useState<string>("A");
  const currentInput = myUtil.pfn(
    current * currentUnits[currentUnit]!.modifier
  );

  const [resistance, setResistance] = useState<number>(275);
  const [resistanceUnit, setResistanceUnit] = useState<string>("Ω");
  const resistanceInput = myUtil.pfn(
    resistance * resistanceUnits[resistanceUnit]!.modifier
  );

  const [power, setPower] = useState<number>(275);
  const [powerUnit, setPowerUnit] = useState<string>("W");
  const powerInput = myUtil.pfn(power * powerUnits[powerUnit]!.modifier);

  const voltageUnitsJSX = Object.keys(voltageUnits).map((unit) => (
    <IonSelectOption
      key={voltageUnits[unit].modifier}
      value={voltageUnits[unit].unit}
    >
      {voltageUnits[unit].text}
    </IonSelectOption>
  ));
  const currentUnitsJSX = Object.keys(currentUnits).map((unit) => (
    <IonSelectOption
      key={currentUnits[unit].modifier}
      value={currentUnits[unit].unit}
    >
      {currentUnits[unit].text}
    </IonSelectOption>
  ));
  const resistanceUnitsJSX = Object.keys(resistanceUnits).map((unit) => (
    <IonSelectOption
      key={resistanceUnits[unit].modifier}
      value={resistanceUnits[unit].unit}
    >
      {resistanceUnits[unit].text}
    </IonSelectOption>
  ));
  const powerUnitsJSX = Object.keys(powerUnits).map((unit) => (
    <IonSelectOption
      key={powerUnits[unit].modifier}
      value={powerUnits[unit].unit}
    >
      {powerUnits[unit].text}
    </IonSelectOption>
  ));

  const statSize = 2;
  const [fieldStack, setFieldStack] = useState<string[]>(["v", "i"]);

  let fieldStats: FieldStatTypeInterface;

  fieldStats = {
    v: true,
    i: true,
    r: false,
    p: false,
  };

  for (let key in fieldStats) {
    if (fieldStack.find((item) => item === key)) fieldStats[key] = true;
    else fieldStats[key] = false;
  }

  let formula: { p: string; v: string; r: string; i: string } =
    Logic.getContentLine1(fieldStats);
  console.log(formula);

  useEffect(() => {
    const enteredOhm: FieldValueType = {
      v: voltage,
      i: current,
      r: resistance,
      p: power,
    };

    const calculatedOhm = Logic.calculateOhmsPair(fieldStats, enteredOhm);
    // console.log(fieldStats);
    // console.log(calculatedOhm);

    // console.log(calculatedOhm);
    if (!calculatedOhm) return;
    setCurrent(calculatedOhm.i);
    setVoltage(calculatedOhm.v);
    setResistance(calculatedOhm.r);
    setPower(calculatedOhm.p);
  }, [voltage, current, resistance, power, fieldStats]);

  const changeUnitHandler = (target: HTMLIonSelectElement) => {
    if (target.name === "voltageUnit") {
      const output = Logic.changeUnit(
        target,
        voltage,
        voltageUnit,
        voltageUnits,
        "V"
      );
      if (output) {
        // voltageInput = voltage * voltageUnits[voltageUnit]!.modifier;
        setVoltageUnit(output.unit);
      }
    }
    if (target.name === "currentUnit") {
      const output = Logic.changeUnit(
        target,
        current,
        currentUnit,
        currentUnits,
        "A"
      );
      if (output) {
        // setCurrent(output.value);
        setCurrentUnit(output.unit);
      }
    }
    if (target.name === "resistanceUnit") {
      const output = Logic.changeUnit(
        target,
        resistance,
        resistanceUnit,
        resistanceUnits,
        "Ω"
      );
      if (output) {
        // setResistance(output.value);
        setResistanceUnit(output.unit);
      }
    }
    if (target.name === "powerUnit") {
      const output = Logic.changeUnit(
        target,
        power,
        powerUnit,
        powerUnits,
        "W"
      );
      if (output) {
        // setResistance(output.value);
        setPowerUnit(output.unit);
      }
    }
  };

  // console.log(fieldStack);

  // useEffect(() => {
  //   for (let key in fieldStats) {
  //     if (fieldStack.find((item) => item === key)) fieldStats[key] = true;
  //     else fieldStats[key] = false;
  //   }

  //   console.log("useEffect", fieldStats);
  // }, [fieldStack, fieldStats]);

  const toggleHandler = (
    e: CustomEvent<ToggleChangeEventDetail>,
    key: string
  ) => {
    if (e.detail.checked) {
      setFieldStack((oldData) => {
        const newData = [...oldData, key];
        console.log("added", key);
        if (newData.length > statSize) console.log("removed", newData.shift());
        console.log("new data", newData);
        return newData;
      });
    } else {
      setFieldStack((oldData) =>
        oldData.filter((dataItem) => dataItem !== key)
      );
    }
  };

  // console.log("======================= PowerPage Rendered");
  return (
    <>
      {!IS_EMBED && <Sidebar />}

      <IonPage id="main-content">
        {!IS_EMBED && (
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="start">
                <IonMenuButton></IonMenuButton>
              </IonButtons>
              <IonTitle>Ohm's Law Calculator</IonTitle>
            </IonToolbar>
          </IonHeader>
        )}
        <IonContent className="ion-padding">
          <IonGrid fixed={true}>
            <IonRow>
              <IonCol size="12" sizeMd="6">
                <IonGrid>
                  <IonRow>
                    <IonCol size="2" className="ion-align-self-center">
                      <IonToggle
                        checked={fieldStats.v}
                        onIonChange={(ev) => toggleHandler(ev, "v")}
                      ></IonToggle>
                    </IonCol>
                    <IonCol>
                      <IonItem fill="solid" disabled={!fieldStats.v}>
                        <IonLabel position="stacked">Voltage (V)</IonLabel>
                        <IonInput
                          type="number"
                          value={voltageInput}
                          onIonInput={(ev) => {
                            setVoltage(
                              myUtil.prepareFloatingNumber(
                                +ev.target!.value! /
                                  voltageUnits[voltageUnit].modifier
                              )
                            );
                          }}
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                    <IonCol size="3">
                      <IonItem fill="solid">
                        <IonLabel position="stacked">units</IonLabel>
                        <IonSelect
                          name="voltageUnit"
                          value={voltageUnit}
                          onIonChange={(ev) => changeUnitHandler(ev.target!)}
                        >
                          {voltageUnitsJSX}
                        </IonSelect>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol size="2" className="ion-align-self-center">
                      <IonToggle
                        checked={fieldStats.i}
                        onIonChange={(ev) => toggleHandler(ev, "i")}
                      ></IonToggle>
                    </IonCol>
                    <IonCol>
                      <IonItem fill="solid" disabled={!fieldStats.i}>
                        <IonLabel position="stacked">Current (I)</IonLabel>
                        <IonInput
                          type="number"
                          step="0.1"
                          value={currentInput}
                          onIonInput={(ev) =>
                            setCurrent(
                              myUtil.pfn(
                                +ev.target!.value! /
                                  currentUnits[currentUnit].modifier
                              )
                            )
                          }
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                    <IonCol size="3">
                      <IonItem fill="solid">
                        <IonLabel position="stacked">Units</IonLabel>
                        <IonSelect
                          name="currentUnit"
                          value={currentUnit}
                          onIonChange={(ev) => changeUnitHandler(ev.target!)}
                        >
                          {currentUnitsJSX}
                        </IonSelect>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol size="2" className="ion-align-self-center">
                      <IonToggle
                        checked={fieldStats.r}
                        onIonChange={(ev) => toggleHandler(ev, "r")}
                      ></IonToggle>
                    </IonCol>
                    <IonCol>
                      <IonItem disabled={!fieldStats.r}>
                        <IonLabel position="stacked">Resistance (R)</IonLabel>
                        <IonInput
                          type="number"
                          value={resistanceInput}
                          onIonInput={(ev) =>
                            setResistance(
                              myUtil.prepareFloatingNumber(
                                +ev.target!.value! /
                                  resistanceUnits[resistanceUnit].modifier
                              )
                            )
                          }
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                    <IonCol size="3">
                      <IonItem fill="solid">
                        <IonLabel position="stacked">Units</IonLabel>
                        <IonSelect
                          name="resistanceUnit"
                          value={resistanceUnit}
                          onIonChange={(ev) => changeUnitHandler(ev.target!)}
                        >
                          {resistanceUnitsJSX}
                        </IonSelect>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol size="2" className="ion-align-self-center">
                      <IonToggle
                        checked={fieldStats.p}
                        onIonChange={(ev) => toggleHandler(ev, "p")}
                      ></IonToggle>
                    </IonCol>
                    <IonCol>
                      <IonItem disabled={!fieldStats.p}>
                        <IonLabel position="stacked">Power (P)</IonLabel>
                        <IonInput
                          type="number"
                          value={powerInput}
                          onIonInput={(ev) =>
                            setPower(
                              myUtil.prepareFloatingNumber(
                                +ev.target!.value! /
                                  powerUnits[powerUnit].modifier
                              )
                            )
                          }
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                    <IonCol size="3">
                      <IonItem fill="solid">
                        <IonLabel position="stacked">Units</IonLabel>
                        <IonSelect
                          name="powerUnit"
                          value={powerUnit}
                          onIonChange={(ev) => changeUnitHandler(ev.target!)}
                        >
                          {powerUnitsJSX}
                        </IonSelect>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonCol>
              <IonCol size="12" sizeMd="6">
                <IonGrid>
                  {fieldStack.length < 2 && (
                    <IonRow>
                      <IonCol>
                        <IonCard color="warning">
                          <IonCardHeader>
                            <IonCardTitle>Attention!</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <p>
                              Please provide two values to start calculating.
                            </p>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                    </IonRow>
                  )}
                  {/* Voltage Result Card */}
                  {!fieldStats.v && fieldStack.length > 1 && (
                    <IonRow>
                      <IonCol>
                        <IonCard className="ion-no-margin">
                          <IonCardHeader color="primary">
                            <IonCardTitle>
                              {myUtil.formatNumber(voltageInput)} {voltageUnit}
                            </IonCardTitle>
                            <IonCardSubtitle>
                              Voltage V = {voltageInput} {voltageUnit} (
                              {voltageUnits[voltageUnit].desc})
                            </IonCardSubtitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <IonItem className="ion-no-padding">
                              <IonIcon
                                icon={returnDownForward}
                                slot="start"
                              ></IonIcon>
                              <IonLabel>{formula.v}</IonLabel>
                            </IonItem>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                    </IonRow>
                  )}

                  {/* Current Card */}
                  {!fieldStats.i && fieldStack.length > 1 && (
                    <IonRow>
                      <IonCol>
                        <IonCard className="ion-no-margin">
                          <IonCardHeader color="primary">
                            <IonCardTitle>
                              {myUtil.formatNumber(currentInput)} {currentUnit}
                            </IonCardTitle>
                            <IonCardSubtitle>
                              Current I = {currentInput} {currentUnit} (
                              {currentUnits[currentUnit].desc})
                            </IonCardSubtitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <IonItem className="ion-no-padding">
                              <IonIcon
                                icon={returnDownForward}
                                slot="start"
                              ></IonIcon>
                              <IonLabel>{formula.i}</IonLabel>
                            </IonItem>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                    </IonRow>
                  )}

                  {/* Resistance Card */}
                  {!fieldStats.r && fieldStack.length > 1 && (
                    <IonRow>
                      <IonCol>
                        <IonCard className="ion-no-margin">
                          <IonCardHeader color="primary">
                            <IonCardTitle>
                              {myUtil.formatNumber(resistanceInput)}{" "}
                              {resistanceUnit}
                            </IonCardTitle>
                            <IonCardSubtitle>
                              Resistance R = {resistanceInput} {resistanceUnit}{" "}
                              ({resistanceUnits[resistanceUnit].desc})
                            </IonCardSubtitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <IonItem className="ion-no-padding">
                              <IonIcon
                                icon={returnDownForward}
                                slot="start"
                              ></IonIcon>
                              <IonLabel>{formula.r}</IonLabel>
                            </IonItem>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                    </IonRow>
                  )}

                  {/* Power Card */}
                  {!fieldStats.p && fieldStack.length > 1 && (
                    <IonRow>
                      <IonCol>
                        <IonCard className="ion-no-margin">
                          <IonCardHeader color="primary">
                            <IonCardTitle>
                              {myUtil.formatNumber(powerInput)} {powerUnit}
                            </IonCardTitle>
                            <IonCardSubtitle>
                              Power P = {powerInput} {powerUnit} (
                              {powerUnits[powerUnit].desc})
                            </IonCardSubtitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <IonItem className="ion-no-padding">
                              <IonIcon
                                icon={returnDownForward}
                                slot="start"
                              ></IonIcon>
                              <IonLabel>{formula.p}</IonLabel>
                            </IonItem>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                    </IonRow>
                  )}
                </IonGrid>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    </>
  );
};

export default Index;
